import * as SwitchPrimitives from '@radix-ui/react-switch'
import clsx from 'clsx'
import * as React from 'react'

import Spinner from '@/components-latest/primitives/Spinner'
import Text from '@/components-latest/primitives/Text'

import Styles from './SwitchWithWords.module.scss'

type Props = {
  onToggle: (value?: boolean) => void
  checked: boolean
  isLoading?: boolean
  checkedWord?: string
  uncheckedWord?: string
  disabled?: boolean
  className?: string
  width?: number
}

const SwitchWithWords = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  Props & React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(
  (
    {
      className,
      onToggle,
      disabled,
      isLoading,
      checkedWord,
      uncheckedWord,
      width = 120,
      ...props
    },
    ref
  ) => {
    const onChangeEnhanced = (e: React.MouseEvent<HTMLButtonElement>) => {
      const checked = e.currentTarget.dataset?.checked
      const parsedChecked = checked === 'true'
      onToggle(!parsedChecked)
    }

    return (
      <SwitchPrimitives.Root
        className={clsx(Styles.root, className)}
        data-checked={props.checked}
        data-testid="switch"
        disabled={disabled || isLoading}
        onClick={onChangeEnhanced}
        style={
          {
            '--block-width': typeof width === 'number' ? `${width}px` : width
          } as React.CSSProperties
        }
        {...props}
        ref={ref}>
        <SwitchPrimitives.Thumb className={Styles.thumb}>
          {isLoading && <Spinner />}
        </SwitchPrimitives.Thumb>
        <div title="Offline" className={clsx(Styles.uncheckedBlock)}>
          <Text weight="bold" className={Styles.word} asChild>
            <p>{uncheckedWord}</p>
          </Text>
        </div>
        <div title="Online" className={clsx(Styles.checkedBlock)}>
          <Text weight="bold" className={Styles.word} asChild>
            <p>{checkedWord}</p>
          </Text>
        </div>
      </SwitchPrimitives.Root>
    )
  }
)
SwitchWithWords.displayName = SwitchPrimitives.Root.displayName

export default SwitchWithWords
